<template>
    <div>
        <a-form :layout="formLayout" :form="form">
            <a-form-item
                v-if="doctors.length>0"
                label="请选择"
                :label-col="formItemLayout.labelCol"
                :wrapper-col="formItemLayout.wrapperCol"
            >
        <a-checkbox-group
            :options="doctors"
            @change="onChange"
        >

        </a-checkbox-group>
            </a-form-item>
            <a-form-item :wrapper-col="buttonItemLayout.wrapperCol"
                         v-if="doctors.length>0"
            >
            <a-button type="primary" icon="plus" @click="addDoctor">确定</a-button>
            </a-form-item>
        </a-form>

        <a-form-item
            :wrapper-col="buttonItemLayout.wrapperCol"
        >
            <h1>暂无可以选择的医生</h1>
            <a-button type="primary" icon="plus" @click="createDoctor">创建医生</a-button>
        </a-form-item>




    </div>
</template>

<script>
    import request from "../../utils/request";
    import Global from '../../global_variable'

    export default {
        data() {
            return {
                formLayout: "horizontal",
                form: this.$form.createForm(this),
                indeterminate: true,
                checkAll: false,
                plainOptions:[],
                //设置上传的请求头部，IE10 以上有效
                headers: {
                    authorization: "authorization-text"
                },
                //上传请求时是否携带 cookie
                withCredentials: true,
                doctors:[],
                value: [],
            };
        },
        mounted() {
            this.getData();
        },
        computed: {
            formItemLayout() {
                const {formLayout} = this;
                return formLayout === "horizontal"
                    ? {
                        labelCol: {span: 4},
                        wrapperCol: {span: 14}
                    }
                    : {};
            },
            buttonItemLayout() {
                const {formLayout} = this;
                return formLayout === "horizontal"
                    ? {
                        wrapperCol: {span: 14, offset: 4}
                    }
                    : {};
            }
        },
        methods: {
            getData() {
                request({
                    url: "/doctor/all_no_page",
                    method: "get",
                    params: {
                        project_id:this.$route.query.the_id
                    }
                }).then(response => {
                    console.log("获取到的参数", response.data.data);
                    if (response.data.success) {
                        let doctors = response.data.data;
                        let index;
                        for(index in doctors){
                            let item =doctors[index];
                            this.doctors.push({ label: "姓名："+item.name+"，手机号："+item.phone, value: item.key });
                        }
                    } else {
                        this.$message.error(response.data.msg)
                    }
                });
            },
            onChange(checkedValues) {
                console.log('checked = ', checkedValues);
                this.value=checkedValues;
                console.log('value = ', this.value);
            },
            createDoctor(){
                this.$router.push({path:'/doctor/add'});
            },
            addDoctor(){
                if(this.value.length<1){
                    this.$message.error("请选择");
                    return;
                }
              console.log("选择的",this.value)
                request({
                    url: "/project_doctor/add/",
                    method: "POST",
                    data: {
                        doctors:this.value,
                        project_id: this.$route.query.the_id
                    }
                }).then(response => {
                    let data = response.data;
                    if (data.success) {
                        this.value=[];
                        this.doctors=[];
                        this.form.resetFields();
                        this.$message.success(data.msg);
                        this.$router.push({path:'/project/all/doctor', query: {the_id:this.$route.query.the_id}});

                    } else {
                        this.$message.error(data.msg);
                    }
                    console.log(response);
                });

            },
        }
    };
</script>
